module.exports = __webpack_public_path__ + "img/scene1.68ef699c.png";